module.exports = __webpack_public_path__ + "media/images/online/online-wedding-lead-f74aa266699bc7d3501029e4841f58fc.png";